import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Modal } from "shared/components/Modal";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";

interface RunReportConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const RunReportConfirmModal = ({
  opened,
  onClose,
  onConfirm,
  isLoading
}: RunReportConfirmModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[420px] w-full ring-1 ring-alpha-100 p-6"
    >
      <div className="flex flex-col items-center">
        <div className="mb-4 rounded-full bg-alpha-40 p-4">
          <HugeiconsIcon
            icon={InformationCircleIcon}
            className="text-content-100"
            size={32}
          />
        </div>

        <div className="flex w-full flex-col gap-6">
          <div>
            <h2 className="mb-1 text-center text-xl font-bold text-content-1000">
              Run report
            </h2>

            <p className="mt-1 text-center text-sm leading-6 text-content-500">
              Running a housing court report without a completed credit report
              may decrease the efficacy of the results. Boom won&apos;t be able
              to use historical addresses from the credit report to improve the
              search results. Would you like to proceed?
            </p>
          </div>

          <div className="flex w-full gap-4">
            <Button
              className="w-full"
              size={ButtonSize.BASE}
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              className="w-full"
              size={ButtonSize.BASE}
              variant={ButtonVariant.PRIMARY}
              onClick={onConfirm}
              loading={isLoading}
            >
              Run
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
